import { render, staticRenderFns } from "./CreditUser.vue?vue&type=template&id=fa045f3e&"
import script from "./CreditUser.vue?vue&type=script&lang=js&"
export * from "./CreditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports